<script>
/**
 * Descripción: Componente Banner the la aplicación
 *
 * @displayName TheBanner
 */
import { butter } from '@/plugins/buttercms';

const BaseCard = () =>
  import(
    /* webpackChunkName: "BlogViewComponent" */ '@/components/core/forms/BaseCard'
  );

export default {
  name: 'TheBanner',

  data() {
    return {
      posts: [],
      select: null
    };
  },

  components: {
    BaseCard
  },

  mounted() {
    this.getPosts();
  },

  methods: {
    getPosts() {
      butter.post.list().then(res => {
        this.posts = res.data.data;
      });
    },

    goToPost() {
      this.$router.push('/' + this.select);
    }
  }
};
</script>

<template>
  <BaseCard dark>
    <v-img
      :src="require('@/assets/app/home.png')"
      class="grey lighten-2"
      height="400"
      width="100%"
    >
      <v-row class="fill-height pa-3" align="center">
        <v-col cols="12" md="8">
          <v-autocomplete
            v-model="select"
            item-text="title"
            item-value="url"
            :items="posts"
            class="mx-4"
            flat
            hide-no-data
            hide-details
            label="Buscar un Post"
            solo-inverted
            @change="goToPost()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <center>
            <v-img
              :src="require('@/assets/logos/logoWhite.svg')"
              max-width="500"
            />
          </center>
        </v-col>
      </v-row>
    </v-img>
  </BaseCard>
</template>
